var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Calendar',{model:{value:(_vm.events),callback:function ($$v) {_vm.events=$$v},expression:"events"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }